import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ToastContext = createContext(null);

let toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);
  }, []);

  const toast = useMemo(() => ({
    info: (msg, duration) => showToast(msg, 'info', duration),
    success: (msg, duration) => showToast(msg, 'success', duration),
    error: (msg, duration) => showToast(msg, 'error', duration),
    warn: (msg, duration) => showToast(msg, 'warn', duration),
  }), [showToast]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{
        position: 'fixed',
        top: '80px',
        right: '20px',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxWidth: '400px',
        pointerEvents: 'none',
      }}>
        {toasts.map(t => (
          <div
            key={t.id}
            style={{
              padding: '14px 20px',
              borderRadius: '10px',
              color: '#fff',
              fontSize: '14px',
              lineHeight: '1.5',
              pointerEvents: 'auto',
              animation: 'toast-slide-in 0.3s ease',
              whiteSpace: 'pre-line',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
              border: '1px solid',
              borderColor: t.type === 'error' ? '#e74c3c' :
                           t.type === 'success' ? '#2ecc71' :
                           t.type === 'warn' ? '#f39c12' : '#3498db',
              background: t.type === 'error' ? 'rgba(231,76,60,0.95)' :
                          t.type === 'success' ? 'rgba(46,204,113,0.95)' :
                          t.type === 'warn' ? 'rgba(243,156,18,0.95)' :
                          'rgba(52,152,219,0.95)',
            }}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    // Fallback if used outside provider — use alert
    return {
      info: (msg) => alert(msg),
      success: (msg) => alert(msg),
      error: (msg) => alert(msg),
      warn: (msg) => alert(msg),
    };
  }
  return ctx;
}
